/**
 * 日付文字列をサービス内の画面表示用の形式に変換する
 * @param date
 */
import moment from 'moment'
import 'moment/locale/ja'
moment.locale('ja')

export const dateConvertiongForView = (datestr: string): string => {
  const timestamp = Date.parse(datestr)
  let date = ''
  const postDate: Date = new Date(timestamp)
  const today = new Date()
  const diff_days = (today.getTime() - postDate.getTime()) / 1000 / 60 / 60 / 24
  if (diff_days > 1) {
    date =
      postDate.getFullYear() + '年' +
      (postDate.getMonth() + 1) +
      '月' +
      postDate.getDate() +
      '日 ' +
      ('0' + postDate.getHours()).slice(-2) +
      ':' +
      ('0' + postDate.getMinutes()).slice(-2)
  } else {
    date = moment(datestr).fromNow()
  }
  return date
}

/**
 * YYYY/mm/ddの形式に変換する
 * @param datetime
 */
export const dateConvertToNormalFormat = (datestr: string): string => {
  const timestamp = new Date(Date.parse(datestr))
  return [
    timestamp.getFullYear(),
    timestamp.getMonth() + 1,
    timestamp.getDate()
  ].join('/')
}

export default { dateConvertiongForView, dateConvertToNormalFormat }
